<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<!-- @submit.prevent="handleSubmit()" -->
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<div class="col-md-4">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.mvtTypeDep')}}
								</label>
								<!--  -->
								<select v-model="mvtTypeDepSelected" class="form-control" :class="{'is-invalid': v$.instance.mvtTypeDep.$error, 'is-valid': (!v$.instance.mvtTypeDep.$error && v$.instance.mvtTypeDep.$dirty) }" :disabled="typeView=='show'">
									<option v-for="mvtTypeDep in mvtTypeDepList" :value="mvtTypeDep.id" :key="mvtTypeDep.id">
										{{mvtTypeDep.typeDepName}}
									</option>
								</select>	
								<span class="small text-muted d-md-block" v-if="v$.instance.mvtTypeDep.$error">
									{{ v$.instance.mvtTypeDep.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-8">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
									</label>
									<!--  -->
									<select v-model="mvtAccountSelected" class="form-control" :class="{'is-invalid': v$.instance.mvtAccount.$error, 'is-valid': (!v$.instance.mvtAccount.$error && v$.instance.mvtAccount.$dirty) }" :disabled="typeView != 'new'">
										<option v-for="mvtAccount in mvtAccountList" :value="mvtAccount.id" :key="mvtAccount.id">
										{{ mvtAccount.lib}} | Solde: {{$store.getters.formatAmount(mvtAccount.solde)}}
										</option>
									</select>
									<span class="small text-muted d-md-block" v-if="v$.instance.mvtAccount.$error">
										{{ v$.instance.mvtAccount.$errors[0].$message }}
									</span>							
								</div>
							</div>
							
							<div class="col-md-8" v-show="typePay == 'ind' || typeView == 'show'">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsPerson')}}
									</label>
									<select v-model="prsPersonSelected" 
										class="form-control" :disabled="typeView == 'show'">
										<!-- <option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option> -->
										<option v-for="prsPerson in prsPersonList" :value="prsPerson.id" :key="prsPerson.id">
											{{prsPerson.fullName}}
										</option>
									</select>					
								</b-form-group>
							</div>
							
							<div class="col-md-4" v-show="typePay == 'ind' || typeView == 'show'">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.payAmount')}}
									</label>
									<input type="number" step="any" v-model="instance.payAmount" class="form-control" :disabled="typeView == 'show'"/>
								</b-form-group>				
							</div>

							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.payDateStart')}}
									</label>
									<input type="date" v-model="instance.payDateStart" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.payDateStart.$error, 'is-valid': (!v$.instance.payDateStart.$error && v$.instance.payDateStart.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-md-block" v-if="v$.instance.payDateStart.$error">
										{{ v$.instance.payDateStart.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.payDateEnd')}}
									</label>
									<input type="date" v-model="instance.payDateEnd" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.payDateEnd.$error, 'is-valid': (!v$.instance.payDateEnd.$error && v$.instance.payDateEnd.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-md-block" v-if="v$.instance.payDateEnd.$error">
										{{ v$.instance.payDateEnd.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.payDate')}}
									</label>
									<!-- <datepicker 
										v-model="instance.payDate"
										:disabled="typeView=='show'"
										:language="language"

										:class="{'is-invalid': v$.instance.payDate.$error, 'is-valid': (!v$.instance.payDate.$error && v$.instance.payDate.$dirty) }"
										/> -->
									<input type="date" v-model="instance.payDate" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.payDate.$error, 'is-valid': (!v$.instance.payDate.$error && v$.instance.payDate.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-md-block" v-if="v$.instance.payDate.$error">
										{{ v$.instance.payDate.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-8">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.justificatif')}}
									</label>
									<input type="text" v-model="instance.justificatif" class="form-control" :class="{'is-invalid': v$.instance.justificatif.$error, 'is-valid': (!v$.instance.justificatif.$error && v$.instance.justificatif.$dirty) }" :disabled="typeView=='show'" />
									<span class="small text-muted d-md-block" v-if="v$.instance.justificatif.$error">
										{{ v$.instance.justificatif.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
						
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.username')}}
									</label>
									<input type="text" v-model="instance.username" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
	
						</div>
						
					</b-form>
				</div>
				<div class="card-body" v-if="typePay === 'all'">
					<div class="datatable">
						<!-- TOTAL -->
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<tbody>
								<tr v-if="payAmountTot > 0" class="border-bottom table-warning">
									<td align="small center" colspan="2" >
										<div class="align-right" >
											{{$t('mvtpayment.payAmountTot')}}
										</div>
									</td>
									<td align="center" colspan="1" >
										<div class="align-right">
											{{$store.getters.formatAmount(payAmountTot)}}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<datatable-instance
							:instanceClassAttr="instanceClassMvtPay"
							ref="componentDatatableInstance"
						/>
					</div>
				</div>
				<div class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])">
					<div class="row">
						<div class="col-md-4" align="left">
							<b-button v-if="typeView != 'show'" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show'" >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show' && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-primary" 
								@click="typeView = 'edit'" >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>

						</div>
						<div class="col-md-4" align="center"></div>
						<div v-if="typeView == 'show'" class="col-md-4" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce()">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('mvtpayment.button.print')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>
				</div>
									
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '@/layouts/templates/Header.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue'

	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'
	export default {
		name: 'mvtPayment',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			},
			accId: {
				type: Number,
				default: NaN,
				required: false
			},
			prsId: {
				type: Number,
				default: NaN,
				required: false
			},
			storeId: {
				type: Number,
				default: NaN,
				required: false
			},
			typePay: {
				type: String,
				default: 'ind',
				required: false
			}
		},
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'modal-pdf-viewer': ModalPdfViewer,
			'datatable-instance': DatatableInstance,
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtpayment.label'),
				pageTitle: this.$t('mvtpayment.show'),
				pageIcon: 'tag',
				instanceClassAttr: {
					instanceClass: 'mvtpayment'
				},

				instance: {},
				vueRules: {},

				mvtTypeDepList:[],
				mvtTypeDepSelected: null,
				
				mvtAccountList:[],
				mvtAccountSelected: null,

				prsPersonList: [],
				prsPersonSelected: null,

				// mvtPayList:[],
				payAmountTot: 0,
				instanceClassMvtPay: {
					instanceClass: 'mvtpayment',
					typeItems: 'itemsInit',
					actCol: {
						actDisplay: false, 
						thCol: '10%',
						thClass: 'align-center',
						// actAlign: 'right',
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false
					},
					attrsList:[
						{attrName:'prsPersonName', thStyle: {width:'60%'}, thClass:'align-center'},
						{attrName:'payAmount', thStyle: {width:'20%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'paySolde', thStyle: {width:'20%'}, thClass:'align-center', searchable: true, sortable: true}
					]
				},

				typeView: 'new',

				amountLetter: {},
				pdfSrc:'',
				pdfName:'Bulletin de paie',				
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.$store.dispatch('initFlash');

			if(this.$store.getters.loggedIn) {
				// GET LIST mvttypedep
				await this.$store.dispatch('axiosGet', {
					domain: 'mvttypedep',
					id:3 // Salaire
				})
				.then(response => {
					this.mvtTypeDepList = [response.data]
					this.mvtTypeDepSelected = response.data.id
				})
				.catch(error => {
					console.log('error catch mvttypedep == ', error.message)
				})
				if(this.typePay)
					this.instance.typePay = this.typePay

				// GET LIST prsperson
				this.getPersonList();

				// GET LIST mvtAccount
				this.getMvtAccountList();
				if(this.itemId && !isNaN(this.itemId)){
					this.typeView = 'show'
					await this.$store.dispatch('axiosGet', {
						domain: 'mvtpayment',
						id: this.itemId
					})
					.then(response => {
						this.instance = response.data

						this.instance.payDate = this.instance.payDate.split('T')[0] // this.$moment(this.instance.payDate).format(this.$store.getters.formatDate)
						this.instance.payDateStart = this.instance.payDateStart.split('T')[0]
						this.instance.payDateEnd = this.instance.payDateEnd.split('T')[0]

						// this.instance.payAmount = this.$store.getters.formatAmount(this.instance.payAmount)
						this.amountToLetter({target:{value:this.instance.payAmount?.toString()}}, 'payAmount')

						this.instance.paySolde = this.$store.getters.formatAmount(this.instance.paySolde)
						this.amountToLetter({target:{value:this.instance.paySolde?.toString()}}, 'paySolde')
						this.prsPersonSelected = this.instance.prsPerson.id
						this.mvtAccountSelected = this.instance.mvtAccount.id


					})
					.catch(error => {
						console.log('error catch get mvtpayment by itemId == ', error.message)
					})
				}
				else {
					if(this.typePay == 'all'){
						// SI GEN RATE GET LIST PAY
						await this.$store.dispatch('axiosGet', { url: '/api/mvtpayment/create'
						})
						.then(response => {
							if(response.data && response.data.mvtPayList ){
								this.$refs.componentDatatableInstance.refreshDataTable(response.data.mvtPayList);
								this.payAmountTot = response.data.payAmountTot
							}

						})
						.catch(error => {
							console.log('error catch - mvtPayList - creates == ', error.message)
						})
					}

					const today = (new Date());
					const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
					const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
					this.instance.payDateStart = firstDay.toISOString().split('T')[0]//this.$moment(firstDay).format(this.$store.getters.formatDate)
					this.instance.payDateEnd = lastDay.toISOString().split('T')[0]// this.$moment(lastDay).format(this.$store.getters.formatDate)
					this.instance.payDate = today.toISOString().split('T')[0]// this.$moment(new Date()).format(this.$store.getters.formatDate)

					const monthName = today.toLocaleString('fr', { month: 'long' });
					const year = today.getFullYear()
					this.instance.justificatif = "Salaire du mois de "+ (monthName?.charAt(0).toUpperCase() + monthName?.slice(1)) +" "+year

					this.instance.username = this.$store.getters.username
				}

				
			}
		},
		methods: {
				
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// EMP -> 1
				strParams = strParams+"&aliasList=_prsType,_prsStore"
				strParams = strParams+"&params1=_prsType.id&valParams1="+1+"&logParams1=eqL"
				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					strParams = strParams+"&params2=_prsStore.id&valParams2="+this.$store.getters.prsInfo.prsStore+"&logParams2=eqL"
				}
				
				strParams = strParams+"&params3=active&valParams3="+true+"&logParams3=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.prsPersonList = response.data
					if(this.prsId && !isNaN(this.prsId)){
						this.prsPersonSelected = this.prsId

						this.prsPersonList = this.prsPersonList.filter(item => item.id == this.prsId)
						this.instance.payAmount = this.prsPersonList[0].pay
					}
					// this.paramsSearch.filterList = response.data	
				})
				.catch(error => {
					console.log('error catch prsPersonList == ', error.message)
				})

			},

			async getMvtAccountList(){
				// logCr=or&
				let strParams = "typeRender=list"

				strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"

				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){

					strParams = strParams+"&params2=prsStore.id&valParams2="+this.$store.getters.prsInfo.prsStore+"&logParams2=eqL"
				}
				else if(this.$store.getters.isAuthorized(['ROLE_MANAGER']) && this.storeId && !isNaN(this.storeId)){
					strParams = strParams+"&params2=prsStore.id&valParams2="+this.storeId+"&logParams2=eqL"
				}

				// strParams = strParams+"&params2=prsStore.id&valParams2="+null+"&logParams2=eqL"

				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data){
						this.mvtAccountList = response.data;
						if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI']) || (this.storeId && !isNaN(this.storeId)) )
							this.mvtAccountSelected = this.mvtAccountList[0].id
					}
				})
				.catch(error => {
					console.log('error catch -mvtAccountList == ', error.message)
				})
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			createVeerules(){
				let rules = {
					instance: {
						mvtAccount: { required },
						mvtTypeDep: {required},
						justificatif: {required},
						payDate: {required},
						payDateStart: {required},
						payDateEnd: {required}
					}
				}
				return rules
			},

			async handleSubmit() {
				this.instance.mvtTypeDep = this.mvtTypeDepSelected
				this.instance.mvtAccount = this.mvtAccountSelected
				this.instance.prsPerson = this.prsPersonSelected	

				const result = await this.v$.$validate()
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'mvtpayment',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("mvtpayment.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.go(0)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.push('/payment/show/'+this.itemId)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPut === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'mvtpayment',
							data: this.instance
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = "Génération des "+ this.instance.justificatif //this.$t("mvtpayment.label");
								if(this.instance.typePay == 'ind' && res.data )
									msg = this.$t("mvtpayment.label") + " "+res.data.id + " du "+this.instance.justificatif;
								console.log('res.data.error : '+res.data.error)
								if(res.data && res.data.error){
									msg = this.$t("mvtpayment.label") + " du "+this.instance.justificatif + " | "+res.data.error;
									this.$store.dispatch('showToast', {
										type: 'danger', message: msg
									});
									// this.$router.go(0)
									this.$router.push('/payment/add/'+this.typePay+'/'+this.prsId+'/'+this.storeId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.created.message', { obj: msg})
									});
									// this.$router.go(0)
									if(this.instance.typePay == 'ind')
										this.$router.push('/payment/show/'+res.data.id)
									else
										this.$router.push('/mvtpayment')
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPost === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
				
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'BULLETIN DE PAIE'
				
				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';

				detailsTop = detailsTop +'<br><br><FONT size=1><i> Bamako le, </i> <b></FONT>' + this.$moment(this.instance.paytDate).format(this.$store.getters.formatDateShort) + '</b>';
				
				let detailsTopC1 = '<i> '+ this.$t('mvtpayment.prsPerson') +' : </i> <b> ' +this.instance.prsPerson.fullName + '</b>';

				detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('prsperson.prsFunction') +' : </i> <b> ' +this.instance.prsPerson?.prsFunction.functionName + '</b>';

				let detailsTopC2 ='<i> '+ this.$t('prsperson.address') +' : </i> <b> ' +this.instance.prsPerson?.address + '</b>';
				detailsTopC2 = detailsTopC2 + '<br><i> '+ this.$t('prsperson.phoneAddress') +' : </i> <b> ' +this.instance.prsPerson?.phoneAddress + '</b>';

				//let	detailsTopC2 = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.payDate).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''
				/*trFoot = '<i> '+ this.$t('mvtmovement.mvtAmount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.mvtAmount) + '</b>';
				
				if(trFoot != '')
					trFoot = trFoot + '<br>'
				trFoot = trFoot + '<i> '+ this.$t('mvtmovement.mvtSolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.mvtSolde) + '</b>';*/
				
				let libBot = '<i> DÉTAILS </i>'
				// let	detailsBot = '. <br>.'
				let detailsBot = '<i> '+ this.$t('mvtpayment.justificatif') +' : </i> <b>' +this.instance?.justificatif + '</b>';
				

				let detailsBotC1 = ''
				let detailsBotC2 = ''
				detailsBotC1 = '<i> '+ this.$t('mvtpayment.payAmount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.payAmount) + '</b>';
				detailsBotC1 = detailsBotC1 + '<br><i><b> '+this.amountLetter.payAmount +'</b> </i>';
				
				if(detailsBotC2 != '')
					detailsBotC2 = detailsBotC2 + '<br>'
				detailsBotC2 = detailsBotC2 + '<i> '+ this.$t('mvtpayment.paySolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.paySolde) + '</b>';
				detailsBotC2 = detailsBotC2 + '<br><i><b> '+this.amountLetter.paySolde +'</b> </i>';

				let strParams = "jasper=LIC&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				if(detailsBotC1 != '')
					strParams = strParams +"&detailsBotC1="+detailsBotC1
				if(detailsBotC2 != '')
					strParams = strParams +"&detailsBotC2="+detailsBotC2
				
				strParams = strParams + "&titreDoc=null"//+ this.$t(this.instanceClassAttr.instanceClass +'.label')

				let fileName = modelName + '_'+this.instance.id
				strParams = strParams + "&fileName="+ fileName
				if(this.instance.mvtAccount.prsStore)
					strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.mvtAccount.prsStore?.storeName +' ***</i></FONT> '

				await this.$store.dispatch('axiosGet', {
					url: '/api/mvtmovement/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},

		}

	}

</script>